/**
 * Primitive Library Page
 *
 * Public page where all authenticated users can browse and search published primitives.
 * Read-only Swagger-style reference — primitives are consumed in the flow editor.
 */

import React from 'react';
import { Info } from 'lucide-react';
import { AppShell } from '@/components/layout/AppShell';
import PrimitiveLibrary from '../components/primitives/PrimitiveLibrary';

export const PrimitiveLibraryPage: React.FC = () => {
  return (
    <AppShell>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-foreground">Primitive Library</h1>
          <p className="text-muted-foreground">
            Browse the catalogue of pre-built test primitives available to your scenario flows.
          </p>
        </div>

        <div className="bg-accent-blue/10 border border-accent-blue/30 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <Info className="w-5 h-5 text-accent-blue flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <h3 className="text-sm font-semibold text-accent-blue mb-1">
                What are Primitives?
              </h3>
              <p className="text-sm text-accent-blue">
                Primitives are low-level, reusable test flows created by system administrators.
                They handle common telecom operations (like checking signal strength or SIM status)
                and can be combined in your scenario flows without writing AT commands directly.
              </p>
            </div>
          </div>
        </div>

        <PrimitiveLibrary />
      </div>
    </AppShell>
  );
};

export default PrimitiveLibraryPage;
